<template>
    <div id="app">
        <!--顶部条-->
        <!--<div style="display:none;"><img src="src/assets/share_logo.png" alt=""></div>-->
        <div v-if="true" style="width: 100%;height: 140pt;background-color: white;position: fixed;z-index: 1">
            <img src="https://eletell.oss-cn-beijing.aliyuncs.com/wlzg/background_res/img_download_share_left_1.png"
                 style="width: 366pt;height: 93pt;position: absolute;left: 30pt;top: 24pt"/>

            <img src="https://eletell.oss-cn-beijing.aliyuncs.com/wlzg/background_res/img_download_share_1.png"
                 style="width: 165pt;height: 69pt;position: absolute;right: 30pt;top: 35pt"
                 @click="androidDownLoad"/>
        </div>
        <div style="display:none;"><img
                src="https://eletell.oss-cn-beijing.aliyuncs.com/wlzg/background_res/share_logo.png" alt=""></div>
        <!--内容-->
        <div class="note" :style="note">
            <!--&lt;!&ndash;Btn IOS下载&ndash;&gt;-->
            <!--<el-button type="primary" :style="shareBtnTop"-->
            <!--@click="iosDownLoad" round>-->
            <!--<span style="font-size: 50px;float:left;margin-left:72px" class="icon-el-icon-btn-ios"></span>-->
            <!--<span style="color: #FFFFFF;float:right;margin-right:240px;margin-top:7px;">IOS下载</span>-->
            <!--</el-button>-->
            <!--<br/>-->
            <!--&lt;!&ndash;Btn Android下载&ndash;&gt;-->
            <!--<el-button type="primary" style="margin-top: 60px;width: 678px;height: 80px;font-size: 36px"-->
            <!--@click="androidDownLoad" round>-->
            <!--<span style="font-size: 55px;float:left;margin-left:72px" class="icon-el-icon-btn-android"></span>-->
            <!--<span style="color: #FFFFFF;float:right;margin-right:235px;margin-top:8px;">安卓下载</span>-->
            <!--</el-button>-->
            <!--<br/>-->
            <!--<el-button type="text" style="margin-top:40px;font-size: 25px;color: #FFFFFF;">-->
            <!--请 根 据 您 的 设 备 选 择 下 载-->
            <!--</el-button>-->
        </div>
        <!--↓遮罩-->
        <div class="mark" v-bind:hidden="isHidden">
            <img src="https://s.blibee.com/res/d.bianlifeng.com/image/app_download/arrow.png"
                 style="position:absolute;right: 100px;top: 50px; "/>
            <div style="font-size: 44px;color: white;margin-top: 500px">右上角选择 "在浏览器中打开" 下载APP</div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                androidApkUrl: "http://oss.eletell.com/wlzg/apk/3.31.0/lighten_own.apk",
                iosAppStoreUrl: "https://itunes.apple.com/cn/app/%E6%9C%AA%E6%9D%A5%E4%B9%8B%E5%85%89/id1416993897?mt=8",
                btnMarginTop: "100px",
                note: {
                    backgroundImage: "",
                    backgroundRepeat: "no-repeat",
                    // backgroundSize: "contain",
                    backgroundSize: "100px 100px",
                    width: "1px",
                    height: "1px",
                    overflow: "auto",
                    marginTop: "130pt"
                },
                shareBtnTop: {
                    marginTop: "100px",
                    width: "678px",
                    height: "80px",
                    fontSize: "36px"
                },
                isHidden: true,
            }
        },
        created: function () {
            this.init();
        },
        methods: {
            init() {
                let imgName = document.location.toString().split("?")[1].replace("id=", "");
                if (imgName.indexOf("&") > -1) {
                    imgName = imgName.substring(0, imgName.indexOf("&"));
                }
                let imgUrl = imgName;
                if(imgName.indexOf("http") === -1){
                    imgUrl = "https://eletell.oss-cn-beijing.aliyuncs.com/zhl_share_pic/" + imgName + ".png";
                }

                this.note.backgroundImage = "url(" + imgUrl + ")";


                let img = new Image();
                let that = this;
                img.src = imgUrl;
                img.onload = function () {
                    // 打印
                    let windowWidth = document.body.clientWidth;
                    if (windowWidth > 1400) {
                        windowWidth = 1400;
                    }
                    let width = img.width;
                    let height = img.height;
                    height = windowWidth * height / width;
                    width = windowWidth;

                    that.note.width = width + "px";
                    that.note.height = height + "px";
                    that.note.backgroundSize = width + "px " + height + "px";
                    let marginTop = height * 4 / 5;
                    that.shareBtnTop.marginTop = marginTop + "px";
                };
            },

            /**
             * IOS下载
             */
            iosDownLoad() {
                window.location.href = this.iosAppStoreUrl;
            },

            /**
             * Android下载
             */
            androidDownLoad() {
                if (this.isWechat()) {
                    this.isHidden = false;
                } else {
                    if (this.isAndroid()) {
                        window.open(this.androidApkUrl);
                    } else if (this.isIOS()) {
                        this.iosDownLoad();
                    }
                }
            },

            toast(msg) {
                this.$message({
                    dangerouslyUseHTMLString: true,
                    message: '<div style="font-size: 35px">' + msg + '</div>',
                    type: 'warning',
                });
            },

            /**
             * 判断浏览器所在机器操作系统版本
             */
            getOsVersion() {
                let u = navigator.userAgent, version = '';
                if (u.indexOf('Mac OS X') > -1) {
                    //ios
                    let regStr_saf = /OS [\d._]*/gi;
                    let verInfo = u.match(regStr_saf);
                    version = (verInfo + "").replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.');
                } else if (u.indexOf('Android') > -1
                    || u.indexOf('Linux') > -1) {
                    //android
                    version = u.substr(u.indexOf('Android') + 8, u.indexOf(";", u.indexOf("Android")) - u.indexOf('Android') - 8);
                } else if (u.indexOf('BB10') > -1) {
                    //黑莓bb10系统
                    version = u.substr(u.indexOf('BB10') + 5, u.indexOf(";", u.indexOf("BB10")) - u.indexOf('BB10') - 5);
                } else if (u.indexOf('IEMobile')) {
                    //windows phone
                    version = u.substr(u.indexOf('IEMobile') + 9, u.indexOf(";", u.indexOf("IEMobile")) - u.indexOf('IEMobile') - 9);
                }
                return version;
            },
            /**
             * 判断是不是微信浏览器
             * @returns {boolean}
             */
            isWechat() {
                return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
            },
            /**
             * 判断是不是Android
             * @returns {boolean}
             */
            isAndroid() {
                let u = navigator.userAgent;
                return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
            },
            /**
             * 判断是不是IOS
             * @returns {boolean}
             */
            isIOS() {
                let u = navigator.userAgent;
                return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            }
        },
    }
</script>

<style>
    #app {
        text-align: center;
        overflow: hidden;
    }

    .mark {
        position: fixed;
        left: 0;
        top: 0;
        opacity: 0.95;
        width: 100%;
        height: 100%;
        background: #000;
        z-index: 998;
    }

    .content {
        position: absolute;
        z-index: 999;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue